import { Observable } from 'rxjs';

import { QuestionBase } from './question-base';

/*

Sample:

new DropdownQuestion({
  key: 'brave',
  label: 'Bravery Rating',
  nullOption: 'Select option...', // to create a default selected null option with provided label
  options: [
    {key: 'solid',  value: 'Solid'},
    {key: 'great',  value: 'Great'},
    {key: 'good',   value: 'Good'},
    {key: 'unproven', value: 'Unproven'}
  ],
  order: 8
})

*/
export class DropdownQuestion extends QuestionBase<string> {
  controlType = 'dropdown';
  options: { key: string; value: string; disabled: string; data?: any }[] = [];
  optionsObservable: Observable<any>;
  nullOption: any = null;
  multiple: boolean;
  enforceValue: boolean;

  constructor(options: {} = {}) {
    super(options);
    this.nullOption = options['nullOption'];
    this.options = options['options'] || [];
    this.optionsObservable = options['optionsObservable'] || null;
    this.multiple = options['multiple'];
    this.controlType = this.multiple ? 'dropdownMultiple' : 'dropdown';
    this.enforceValue = options['enforceValue'] ? options['enforceValue'] : false;

    if (this.optionsObservable) {
      this.optionsObservable.subscribe((opts) => {
        this.options = opts.options || [];
        this.forceUpdate();
      });
    }
  }

  forceUpdate(): void {
    if (this.form) {
      const lastval = this.form && this.form.controls[this.key].value;
      this.form.controls[this.key].reset('reset');
      setTimeout(() => {
        this.form.controls[this.key].setValue(lastval);
      }, 1);
    }
  }

  getData(value: string): any {
    const data = this.options.find((option) => option['key'] === value)['data'];
    return data;
  }
}
